import React from "react";
import BrowserBezel from "components/BrowserBezel";
import { usePagePreviewUrl } from "utils/hooks";
import { useIsAuthed } from "utils/selectors";

const PagePreviewBrowserBezel = ({ liveUrl }) => {
  const href = liveUrl && usePagePreviewUrl(liveUrl);
  const isAuthed = useIsAuthed();
  const bezelProps = {
    placeholder: isAuthed
      ? "Publish this page to visit the live version"
      : "Signup to publish your own pages."
  };
  if (href) {
    const copy = href && href.split("?")[0];

    bezelProps.href = href;
    if (copy) {
      bezelProps.copy = copy;
    }
  }
  return <BrowserBezel {...bezelProps} />;
};

export default PagePreviewBrowserBezel;
